import React, { useState, useEffect } from 'react'
import Button from 'react-bootstrap/Button';
import { toast } from "react-toastify";
import * as Yup from 'yup';
import { useNavigate } from 'react-router';
import { SlDrawer, SlInput, SlIcon } from '@shoelace-style/shoelace/dist/react';
import { useFormik } from "formik";
import api from "../../services/api";
import NoDataFound from '../../shared/NoDataFound';
import { Toast } from '../../shared/Toast';
import Paginator from '../../shared/Paginator';
import config from '../../config';
import TableLoader from '../../shared/TableLoader';
import { useSelector } from 'react-redux';
import { roles } from "../../utils/constants";
import { useForm } from "react-hook-form";
import { debounce } from '../../utils/Debounce';
import { SlTooltip, SlIconButton, SlButton } from '@shoelace-style/shoelace/dist/react';
import * as XLSX from 'xlsx';
import { formatDate } from "../../utils/dateFormat";
import { CSVLink } from "react-csv";


const initialAgencyData = {
    name: '',
    designation: '',
    official_email: '',
    personal_email: '',
    mobile: '',
    company: '',
    location: '',
    category: '',
    source: '',
    brands: ''
}

let initialValues = JSON.parse(JSON.stringify(initialAgencyData));

const AgencySchema = Yup.object().shape({
    name: Yup.string().matches(/^[a-zA-Z][a-zA-Z\s.]*$/, "Name can't start with white space and should not contain special characters").required('Please enter the Name'),
    official_email: Yup.string().email().nullable(),
    personal_email: Yup.string().email().nullable(),
    mobile: Yup.string().nullable().matches(/^(?:(?:\+\d{1,3}\s?)?(\d{10})|(?:0\d{1,5}\s?(\d{6,8}))|(\d+))$/, "Enter the valid Mobile Number"), // Accepts Mobile number with country code, landline number , Company Number
    location: Yup.string().matches(/^[a-zA-Z][a-zA-Z\s]*$/, "Location can't start with white space and should not contain special characters").nullable(),
    source: Yup.string().matches(/^[a-zA-Z][a-zA-Z\s._]*$/, "Source must have only alphabets").nullable(),
    company: Yup.string().matches(/^(?!\s)[a-zA-Z0-9\s]*$/, "Company must be Alphanumeric").nullable(),
    category: Yup.string().matches(/^[a-zA-Z][a-zA-Z\s._]*$/, "Category must have only alphabets").nullable(),
    designation: Yup.string().matches(/^(?!^\s)[a-zA-Z0-9\s@%$&*():;"'/+=\-_.,|]+$/, "Enter valid Designation").required("Please enter the Designation"),
    brands: Yup.string().nullable().matches(/^(?!\s)[a-zA-Z0-9\s!@#\$%\^&*\(\)_\-–=+\[\]{};:'",.<>?/\\|~`]+$/, "Enter valid Brands")
})
const AgencyFileUploadSchema = Yup.object().shape({
    Name: Yup.string().matches(/^[a-zA-Z][a-zA-Z\s.]*$/, "Name can't start with white space and should not contain special characters").required('Please enter the Name'),
    Official_Email: Yup.string().email().nullable(),
    Personal_Email: Yup.string().email().nullable(),
    Mobile: Yup.string().nullable().matches(/^(?:(?:\+\d{1,3}\s?)?(\d{10})|(?:0\d{1,5}\s?(\d{6,8}))|(\d+))$/, "Enter the valid Mobile Number"), // Accepts Mobile number with country code, landline number , Company Number
    Location: Yup.string().matches(/^[a-zA-Z][a-zA-Z\s]*$/, "Location can't start with white space and should not contain special characters").nullable(),
    Source: Yup.string().matches(/^[a-zA-Z][a-zA-Z\s._]*$/, "Source must have only alphabets").nullable(),
    Company_Name: Yup.string().matches(/^(?!\s)[a-zA-Z0-9\s]*$/, "Company must be Alphanumeric").nullable(),
    Category: Yup.string().matches(/^[a-zA-Z][a-zA-Z\s._]*$/, "Category must have only alphabets").nullable(),
    Designation: Yup.string().matches(/^(?!^\s)[a-zA-Z0-9\s@%$&*():;"'/+=\-_.,|]+$/, "Enter valid Designation").required("Please enter the Designation"),
    Brands: Yup.string().nullable().matches(/^(?!\s)[a-zA-Z0-9\s!@#\$%\^&*\(\)_\-–=+\[\]{};:'",.<>?/\\|~`]+$/, "Enter valid Brands")
})

function AgencyData() {
    const navigate = useNavigate();

    const [delId, setDelId] = useState(-1);
    const [delname, setDelname] = useState("")
    const [del, setDel] = useState(false);
    const [view, setView] = useState(false);
    const [data, setData] = useState([]);
    const [show, setShow] = useState(false);
    const [loader, setLoader] = useState(false);
    const [submit, setSubmit] = useState(false);
    const [flag, setFlag] = useState('')
    const [id, setId] = useState('');
    const [search, setSearch] = useState("")
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [userId, setuserId] = useState("")
    const [contactId, setContactId] = useState("")
    const [requestStatus, setRequestStatus] = useState("")
    const [downloadData, setDownloadData] = useState([]);
    const [brands, setBrands] = useState("")
    const [selectedRecords, setSelectedRecords] = useState([]);
    const [selectAll, setSelectAll] = useState(false);

    const toggleCheckbox = (recordId) => {
        if (selectedRecords.includes(recordId)) {
            setSelectedRecords(selectedRecords.filter((id) => id !== recordId));
        } else {
            setSelectedRecords([...selectedRecords, recordId]);
        }
    };

    const toggleSelectAll = () => {
        if (selectAll) {
            setSelectedRecords([]);
        } else {
            const pageRecordIds = data.map((item) => item.contact_id);
            setSelectedRecords(pageRecordIds);
        }
        setSelectAll(!selectAll);
    };

    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
        loadData(search, event.selected);
    };

    const handleClose = () => {
        setShow(false);
        setSubmit(false);
        setView(false)
        initialValues = JSON.parse(JSON.stringify(initialAgencyData));
        formik.setValues(initialValues);
    };

    const handleShow = (choose, item) => {
        if (choose === "add") {
            formik.setValues(item);
            setShow(true);
        }
        if (choose === 'edit') {
            initialValues.name = item.name
            initialValues.designation = item.designation
            initialValues.official_email = item.official_email
            initialValues.personal_email = item.personal_email
            initialValues.mobile = item.mobile
            initialValues.company = item.company
            initialValues.location = item.location
            initialValues.category = item.category
            initialValues.source = item.source
            initialValues.brands = item.brands
            formik.setValues(initialValues);
            setShow(true)
        }
    };

    // useEffect(() => {
    //     if (localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson) {
    //         loadData();
    //     }
    // }, []);
    // useEffect(() => {
    //     if (localStorage.getItem("role") === roles.b2b) {
    //         downloadAgencyContacts("")
    //     }
    // }, []);

    useEffect(() => {
        if (localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson) {
            loadData();
        }
        if (localStorage.getItem("role") === roles.b2b) {
            downloadAgencyContacts("")
        }
    }, [contactId]);

    const deleteContact = async (selectedRecords) => {
        try {
            let res = await api({
                url: `/agency_data/deleteAgencyData`,
                method: "DELETE",
                responseType: "json",
                data: { ids: selectedRecords }
            });
            if (res?.code !== 200) {
                toast.error(res?.data?.message)
            } else {
                toast.success("Contact Deleted Successfully");
                setCurrentPage(0);
                setSearch('');
                loadData(search, 0);
                downloadAgencyContacts(search);
                setSelectedRecords([]);
                setSelectAll(false);
            }
        } catch (error) {
            let er = error?.response?.message || "Something went wrong"
            Toast("error", er)
            if (error.response.status === 401)
                navigate("/")
        }
    }

    const loadData = async (searchString = '', page = 0) => {
        try {
            if (localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson) {
                setLoader(true);
                let res = await api({
                    url: `/agency_data/get`,
                    method: "POST",
                    responseType: "json",
                    data: {
                        page,
                        limit: 100,
                        search: searchString
                    }
                }); if (res?.code === 200) {
                    setData(res.data.data.length ? res.data.data : []);
                    setuserId(res.data.user_id);
                    // setTotalPages(Math.ceil(res.data.total / config.PER_PAGE));
                    setTotalPages(Math.ceil(res.data.total / 100));
                    setLoader(false);
                } else {
                    toast.error(res?.data?.message)
                }
            }
        } catch (error) {
            setLoader(false);
            if (error.response.status === 401)
                navigate("/")
        }
    }
    const downloadAgencyContacts = async (searchString = '') => {
        try {
            if (localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson) {
                setLoader(true);
                let res = await api({
                    url: `/agency_data/downloadAgencyData`,
                    method: "POST",
                    responseType: "json",
                    data: {
                        search: searchString
                    }
                });
                if (res?.code !== 200) {
                    toast.error(res?.data?.message)
                } else {
                    setDownloadData(res.data.data);
                    setuserId(res.data.user_id);
                    setLoader(false);
                }
            }
        } catch (error) {
            setLoader(false);
            if (error.response.status === 401)
                navigate("/")
        }
    }

    const sendRequest = async (contact_id) => {
        try {
            let res = await api({
                url: `/agency_data/request/${contact_id}`,
                method: "POST",
                responseType: "json"
            });
            if (res?.code === 200) {
                toast.success("Request sent Successfully");
                loadData('', 0)

            } else {
                setRequestStatus(res?.data?.message)
                toast.error(res.data.message)
            }
        } catch (error) {
            let er = error?.response?.message || "Something went wrong"
            Toast("error", er)
            if (error.response.status === 401)
                navigate("/")
        }

    }

    const viewBrands = async (contact_id) => {

        if (localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson) {
            try {
                let res = await api({
                    url: `/agency_data/viewBrands/${contact_id}`,
                    method: "POST",
                    responseType: "json"
                });
                if (res?.code === 200) {
                    setBrands(res.data.result);
                    loadData(search, currentPage);
                    setCurrentPage(currentPage)
                    toast.success("Brands displayed successfully")

                } else {
                    toast.error(res?.data?.message);
                }
            } catch (error) {
                let er = error?.response?.message || "Something went wrong"
                Toast("error", er)
                if (error.response.status === 401)
                    navigate("/")
            }
        }


    }

    const brandsArray = brands.split(/,(?![^\s]*&)/);

    const searchData = e => {
        setSearch(e.target.value);
        setCurrentPage(0);
        loadData(e.target.value, 0);
        if (localStorage.getItem("role") === roles.b2b) {
            downloadAgencyContacts(e.target.value)
        }
    }

    function handleRequestClose(event) {
        if (event.detail.source === 'overlay') {
            event.preventDefault();
        }
    }

    const handledelClose = () => {
        setDel(false)
    };

    // const [jsonData, setJsonData] = useState(null);

    // const handleFileUpload = async (event) => {
    //     const file = event.target.files[0];
    //     if (!file) {
    //         return;
    //     }

    //     try {
    //         const arrayBuffer = await file.arrayBuffer();
    //         const workbook = XLSX.read(arrayBuffer, { type: 'array' });
    //         const sheetName = workbook.SheetNames[0];
    //         const worksheet = workbook.Sheets[sheetName];
    //         const convertedData = XLSX.utils.sheet_to_json(worksheet);
    //         setJsonData(convertedData);
    //     } catch (error) {
    //         console.error('Error converting Excel to JSON:', error);
    //     }
    // };
    const {
        register,
        setValue,
        formState: { errors },
    } = useForm({ mode: "onSubmit" });

    const [file, setFile] = useState(null);
    const [jsonData, setJsonData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const handleFileUpload = async (event) => {
        setFile(event.target.files[0]);
        if (event.target.files[0]) {
            if (event.target.files[0].type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                // Throw an error if the file type is not XLSX
                Toast('error', "Please upload file with .xlsx extension")
                return;
            }
            else {
                setIsLoading(true);
                let errorRows = [];
                try {
                    const arrayBuffer = await event.target.files[0].arrayBuffer();
                    const workbook = XLSX.read(arrayBuffer, { type: 'array' });
                    let sheetsCount = Object.keys(workbook.Sheets).length;

                    const sheetName = workbook.SheetNames[0];
                    const worksheet = workbook.Sheets[sheetName];
                    const convertedData = XLSX.utils.sheet_to_json(worksheet);
                    // Validate data against Yup schema
                    convertedData.forEach((data, index) => {
                        try {
                            Object.keys(data).forEach((key) => {
                                if (typeof data[key] === 'string') {
                                    data[key] = data[key].trim();
                                }
                            });
                            AgencyFileUploadSchema.validateSync(data, { abortEarly: false });
                        } catch (error) {
                            console.error(`Validation error in row ${index + 2}:`);
                            errorRows.push(index + 2); // Store the row number with error
                            error.errors.forEach((errorMessage) => {
                                console.error(`${index + 2}: - ${errorMessage}`);
                            });
                        }
                    });

                    setJsonData(convertedData);


                    if (errorRows.length === 0) {
                    let response = await api({
                        url: `/agency_data/uploadContactFile`,
                        method: "POST",
                        responseType: "json",
                        data: {
                            convertedData,
                            sheetsCount
                        }
                    })

                    if (response.code === 200) {
                        toast.success("Contacts added successfully");
                        loadData('', 0)
                        downloadAgencyContacts('')
                        setFile(null)
                    } else {
                        toast.error(response.data.message);
                        loadData('', 0)
                        downloadAgencyContacts('')
                        setFile(null)
                    }
                    }
                    else {
                        console.error("Validation errors found in rows:", errorRows);
                    }
                } catch (error) {
                    console.error('Error converting Excel to JSON:', error);
                } finally {
                    setIsLoading(false);
                }
                setValue('file_xlsx', '')
            }
        } 
        else {
            return
        }

    }; 

    const handleConvert = async () => {
        if (!file) {
            return;
        }

        try {
            const arrayBuffer = await file.arrayBuffer();
            const workbook = XLSX.read(arrayBuffer, { type: 'array' });
            let sheetsCount = Object.keys(workbook.Sheets).length;
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];

            const convertedData = XLSX.utils.sheet_to_json(worksheet);
            setJsonData(convertedData);
            let response = await api({
                url: `/agency_data/uploadContactFile`,
                method: "POST",
                responseType: "json",
                data: {
                    convertedData,
                    sheetsCount
                }
            })
            if (response.code === 200) {
                toast.success("COntacts added successfully")
            } else {
                toast.error(response.data.message)
            }
        } catch (error) {
            console.error('Error converting Excel to JSON:', error);
        }
    };
    const downloadSampleExcel = () => {
        const wb = XLSX.utils.book_new();
        const wsData = [['Name', 'Designation', 'Official_Email', 'Personal_Email', 'Mobile', 'Company_Name', 'Location', 'Category', 'Source', 'Brands']]; // Column names
        const ws = XLSX.utils.aoa_to_sheet(wsData);
        XLSX.utils.book_append_sheet(wb, ws, 'SampleSheet');
        XLSX.writeFile(wb, 'SampleAgencyData.xlsx'); // Download the file
    };
    let formik = useFormik({
        initialValues: JSON.parse(JSON.stringify(initialAgencyData)),
        validationSchema: AgencySchema,
        onSubmit: async (values) => {
            if (flag === 'add') {
                try {
                    let res = await api({
                        url: `/agency_data/add`,
                        method: "POST",
                        responseType: "json",
                        data: values
                    });
                    if (res?.code !== 200) {
                        Toast('error', res?.data?.message);
                    } else {
                        Toast("success", "Contact Added Successfully");
                        handleClose();
                        setCurrentPage(0);
                        setSearch('');
                        loadData(search, 0);
                        downloadAgencyContacts('')
                    }
                } catch (error) {
                    let er = error?.response?.message || "Something went wrong"
                    Toast("error", er)
                    if (error.response.status === 401)
                        navigate("/")
                }
            }
            if (flag === 'edit') {
                try {
                    let res = await api({
                        url: `/agency_data/edit/${id}`,
                        method: "PUT",
                        responseType: "json",
                        data: values
                    });
                    if (res?.code === 200) {
                        Toast("success", "Contact updated Successfully");
                        handleClose()
                        loadData(search, currentPage);
                        downloadAgencyContacts(search)
                        values.name = ''
                        values.designation = ''
                        values.official_email = ''
                        values.personal_email = ''
                        values.mobile = ''
                        values.company = ''
                        values.location = ''
                        values.category = ''
                        values.source = ''
                        values.brands = ''
                    } else {
                        toast.error(res?.data?.message)
                    }
                } catch (error) {
                    let er = error?.response?.message || "Something went wrong"
                    Toast("error", er)
                    if (error.response.status === 401)
                        navigate("/")
                }
            }
        }
    });

    const csvHeaders = [
        { label: "Name", key: "Name" },
        { label: "Designation", key: "Designation" },
        { label: "Official_Email", key: "Official_Email" },
        { label: "Personal_Email", key: "Personal_Email" },
        { label: "Mobile", key: "Mobile" },
        { label: "Company_Name", key: "Company_Name" },
        { label: "Location", key: "Location" },
        { label: "Category", key: "Category" },
        { label: "Source", key: "Source" },
        { label: "Brands", key: "Brands" }
    ];
    return (
        <>
            <SlDrawer label="Are you sure!" open={del} onSlRequestClose={handleRequestClose} onSlAfterHide={handledelClose} style={{ '--size': '30vw' }}>
                {/* <p><span style={{ fontFamily: "Arial", fontWeight: "bold" }}>{delname}</span> will be deleted</p> */}
                <p><span style={{ fontFamily: "Arial", fontWeight: "bold" }}>Selected Contacts</span> will be deleted</p>
                <div className='d-flex gap-2'>
                    <Button variant="success" onClick={() => setDel(false)}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={async () => { setDel(false); await deleteContact(selectedRecords); setSelectAll(false); setSelectedRecords([]) }}>Confirm</Button>
                </div>
            </SlDrawer>

            <SlDrawer label="Brands Handled" open={view} onSlRequestClose={handleRequestClose} onSlAfterHide={handleClose} style={{ '--size': '30vw' }}>
                <div>
                    <h2>Brands:</h2>
                    <ul>
                        {brandsArray.map((brand, index) => (
                            <li key={index}>{index + 1}.{brand.trim()}</li>
                        ))}
                    </ul>
                </div>

            </SlDrawer>
            <div className='flex gap-4 justify-end flex-wrap mb-4'>
                {localStorage.getItem("role") === roles.b2b ? (< div className="flex justify-end">
                    {selectedRecords.length > 0 && (
                        <SlButton variant="primary" size="medium" onClick={async () => { setDel(true) }}>Delete Selected</SlButton>
                    )}
                </div>
                ) : null}
                <SlInput size="medium" id="myInput" onSlInput={debounce(searchData, 500)} placeholder="Search By Company / Category / Location / Designation" >
                    <SlIcon library="lucide" name="search" slot="prefix"></SlIcon>
                </SlInput>
                {(localStorage.getItem("role") === roles.b2b) ? (<div className="moreOptions">
                    {(localStorage.getItem("role") === roles.b2b) ? (<div>
                        <label className="m-0">
                            <i className="bi bi-download px-2 py-1 rounded-lg  bg-slate-100 hover:text-cyan-500 cursor-pointer hover:bg-slate-150" data-toggle="tooltip" title="Download Sample File" onClick={downloadSampleExcel}></i>
                        </label>
                    </div>) : null}
                    {(localStorage.getItem("role") === roles.b2b) ? (<div className="d-flex">
                        <CSVLink
                            data={downloadData}
                            headers={csvHeaders}
                            filename={`Agency_contacts.csv`}
                        >
                            <i className="bi bi-download px-2 py-1 rounded-lg  bg-slate-100 hover:text-cyan-500 cursor-pointer hover:bg-slate-150" data-toggle="tooltip" title="Download Birdview Data"></i>
                            {/* <sl-icon-button
                                    library="lucide"
                                    title="Download Data"
                                    name="download"
                                ></sl-icon-button> */}
                        </CSVLink>
                    </div>) : null}

                    {(localStorage.getItem("role") === roles.b2b) ? (<div className='d-flex'>
                        <label htmlFor="file" className="m-0">
                            <i className="bi bi-arrow-up-circle px-2 py-1 rounded-lg  bg-slate-100 hover:text-cyan-500 cursor-pointer hover:bg-slate-150" data-toggle="tooltip" title="Upload Contacts File"></i>
                            <input type="file" id="file" style={{ display: "none" }} name="file"
                                {...register("file_xlsx", {
                                    required: false,
                                    onChange: (e) => handleFileUpload(e),
                                })} />
                        </label>

                        {isLoading ? (
                            <div className="loader">
                                <div className="spinner-border text-primary" role="status"  >
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        ) : null}
                    </div>) : null}
                </div>) : null}

                {(localStorage.getItem("role") === roles.b2b) ? (<SlButton size="medium" variant="primary" onClick={() => { handleShow("add", {}); setFlag('add') }}>Add Contact</SlButton>) : null}
            </div >
            <SlDrawer label="Create Contact" open={show} onSlRequestClose={handleRequestClose} onSlAfterHide={handleClose} >
                <form onSubmit={formik.handleSubmit}>
                    <div className="mb-3">
                        <label className="mb-1"> Name</label><span className="text-red-600">*</span>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Name"
                            aria-label=""
                            name="name"
                            value={formik.values.name}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.name ? (
                            <div className="text-red-600">{formik.errors.name}</div>
                        ) : null}
                    </div>
                    <div className="mb-3" >
                        <label className="mb-1"> Designation</label><span className="text-red-600">*</span>
                        <input
                            className="form-control"
                            type='text'
                            name='designation'
                            placeholder='Enter Designation'
                            aria-label=""
                            value={formik.values.designation}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.designation ? (
                            <div className="text-red-600">{formik.errors.designation}</div>
                        ) : null}
                    </div>
                    <div className="mb-3" >
                        <label className="mb-1">Official Email</label>
                        <input
                            type='email'
                            className="form-control"
                            placeholder='Enter Official Email'
                            name='official_email'
                            aria-label=""
                            value={formik.values.official_email}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.official_email ? (
                            <div className="text-red-600">{formik.errors.official_email}</div>
                        ) : null}
                    </div>
                    <div className="mb-3" >
                        <label className="mb-1">Personal Email</label>
                        <input
                            type='email'
                            className="form-control"
                            placeholder='Enter Personal Email'
                            name='personal_email'
                            aria-label=""
                            value={formik.values.personal_email}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.personal_email ? (
                            <div className="text-red-600">{formik.errors.personal_email}</div>
                        ) : null}
                    </div>
                    <div className="mb-3" >
                        <label className="mb-1"> Mobile No</label>
                        <input
                            className="form-control"
                            type='tel'
                            name='mobile'
                            placeholder='Enter Mobile No'
                            aria-label=""
                            value={formik.values.mobile}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.mobile ? (
                            <div className="text-red-600	">{formik.errors.mobile}</div>
                        ) : null}
                    </div>
                    <div className="mb-3" >
                        <label className="mb-1"> Company Name</label>
                        <input
                            className="form-control"
                            type='text'
                            name='company'
                            placeholder='Enter Company Name'
                            aria-label=""
                            value={formik.values.company}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.company ? (
                            <div className="text-red-600">{formik.errors.company}</div>
                        ) : null}
                    </div>
                    <div className="mb-3" >
                        <label className="mb-1"> Location</label>
                        <input
                            className="form-control"
                            type='text'
                            name='location'
                            placeholder='Enter location'
                            aria-label=""
                            value={formik.values.location}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.location ? (
                            <div className="text-red-600	">{formik.errors.location}</div>
                        ) : null}
                    </div>
                    <div className="mb-3" >
                        <label className="mb-1"> Category</label>
                        <input
                            className="form-control"
                            type='text'
                            name='category'
                            placeholder='Enter Category'
                            aria-label=""
                            value={formik.values.category}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.category ? (
                            <div className="text-red-600">{formik.errors.category}</div>
                        ) : null}
                    </div>
                    <div className="mb-3" >
                        <label className="mb-1"> Source</label>
                        <input
                            className="form-control"
                            type='text'
                            name='source'
                            placeholder='Enter Source'
                            aria-label=""
                            value={formik.values.source}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.source ? (
                            <div className="text-red-600">{formik.errors.source}</div>
                        ) : null}
                    </div>
                    <div className="mb-3" >
                        <label className="mb-1"> Brands Handled</label>
                        <input
                            className="form-control"
                            type='text'
                            name='brands'
                            placeholder='Enter Handled Brands'
                            aria-label=""
                            value={formik.values.brands}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.brands ? (
                            <div className="text-red-600">{formik.errors.brands}</div>
                        ) : null}
                    </div>
                    <div slot="footer">
                        <SlButton
                            type="submit"
                            variant="primary"
                            size="small"
                            onClick={(e) => setSubmit(true)}>Submit</SlButton>
                    </div>

                </form>
            </SlDrawer>
            < div className='overflow-x-auto mb-4' >
                <table className='table table-bordered'>
                    <thead className="sticky top-0 ">
                        <tr>
                            {(localStorage.getItem("role") === roles.b2b) ? (<th>
                                <input
                                    type="checkbox"
                                    checked={selectAll}
                                    onChange={toggleSelectAll}
                                />
                            </th>) : null}
                            <th >Name</th>
                            <th>Designation</th>
                            <th >Official Email</th>
                            <th >Personal Email</th>
                            <th >Mobile</th>
                            {(localStorage.getItem("role") === roles.salesperson) ? (<th>Expiry Date</th>) : null}
                            <th >Company Name</th>
                            <th>Location</th>
                            <th>Category</th>
                            {(localStorage.getItem("role") === roles.b2b) ? (<th>Source</th>) : null}
                            <th>Brands Handled</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    {(data?.length && !loader) ? (
                        <tbody>
                            {data.map((item) => {
                                return (
                                    <tr key={item.contact_id} className="group/details hover:bg-slate-100">
                                        {(localStorage.getItem("role") === roles.b2b) ? (<td>
                                            <input
                                                type="checkbox"
                                                checked={selectedRecords.includes(item.contact_id)}
                                                onChange={() => toggleCheckbox(item.contact_id)}
                                            />
                                        </td>) : null}
                                        <th scope='row' >{item.name}</th>
                                        <td>{item.designation || '-'}</td>
                                        {(localStorage.getItem("role") === roles.b2b) ? (<td>{item.official_email || '-'}</td>) : <td>{item.official_email || 'xxxxxxxxxx@gmail.com'}</td>}
                                        {(localStorage.getItem("role") === roles.b2b) ? (<td>{item.personal_email || '-'}</td>) : <td>{item.personal_email || 'xxxxxxxxxx@gmail.com'}</td>}
                                        {(localStorage.getItem("role") === roles.b2b) ? (<td>{item.mobile || '-'}</td>) : <td>{item.mobile || '+91xxxxxxxxxx'}</td>}
                                        {/* <td>{item.official_email || 'xxxxxxxxxx@gmail.com'}</td>
                                        <td>{item.personal_email || 'xxxxxxxxxx@gmail.com'}</td>
                                        <td>{item.mobile || '+91xxxxxxxxxx'}</td> */}
                                        {(localStorage.getItem("role") === roles.salesperson) ? (<td>{(item.expiry) ? (formatDate(item.expiry)) : "-"}</td>) : null}
                                        <td>{item.company || '-'}</td>
                                        <td>{item.location || '-'}</td>
                                        <td>{item.category || '-'}</td>
                                        {(localStorage.getItem("role") === roles.b2b) ? (<td>{item.source}</td>) : null}
                                        {/* <td>{item.brands || '-'}</td> */}
                                        {/* {item.brands
                                            ? item.brands.split(',').map((brand, index) => (
                                                <div key={index}>{brand.trim()}</div>
                                            ))
                                            : '-'} */}
                                        {
                                            item.brands ?
                                                <>
                                                    <button variant="primary" size="small" onClick={async () => { setView(true); viewBrands(item.contact_id) }}>View Brands</button>
                                                </> : '-'
                                        }
                                        <td >
                                            <div className='inline-flex gap-3'>
                                                {(localStorage.getItem("role") === roles.b2b) ? (< SlTooltip content="Edit Contact">
                                                    <SlIconButton
                                                        library="lucide"
                                                        name="edit"
                                                        onClick={() => { handleShow("edit", item); setFlag('edit'); setId(item.contact_id) }}></SlIconButton>
                                                </SlTooltip>) : null}
                                                <form action="" method="POST">
                                                    {/* {(localStorage.getItem("role") === roles.b2b) ? (<SlTooltip content="Delete Contact">
                                                        <SlIconButton
                                                            library="lucide"
                                                            name="trash-2"
                                                            onClick={() => { setDel(true); setDelId(item.contact_id); setDelname(item.name) }}></SlIconButton>
                                                    </SlTooltip>) : null} */}
                                                    {(localStorage.getItem("role") === roles.salesperson && (item.status === null || item.status === 2)) ? (<SlTooltip content="Request Details">
                                                        <SlIconButton
                                                            library="lucide"
                                                            name="users"
                                                            onClick={() => { setContactId(item.contact_id); sendRequest(item.contact_id) }}
                                                        >
                                                        </SlIconButton>
                                                    </SlTooltip>) : item.status}
                                                </form>
                                            </div>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>) : ((!data?.length && !loader)
                            ? <NoDataFound colspan="8" />
                            : <TableLoader colspan="8" />
                    )
                    }
                </table>
            </div >
            <div className="flex justify-end"> {totalPages > 1 && <Paginator pageCount={totalPages} handlePageClick={handlePageClick} forcePage={currentPage} />}</div>

        </>
    )
}
export default AgencyData